import { schema } from "@app/schema";

export const selectTheme = schema.theme.select;
